import $ from 'jquery';
import slick from 'slick-carousel';

// init
$( () => {
  let $slickHero = $('.slick-hero');

  if ( $slickHero.length ) {
    let slickPrev = $slickHero.find( '.slick-prev' )
    let slickNext = $slickHero.find( '.slick-next' )
    // nav slider left
    slickPrev.on( 'click' , (e) => {
      e.preventDefault();
      $slickHero.slick('slickPrev');
    });
    
    // nav slider right
    slickNext.on( 'click' , (e) => {
      e.preventDefault();
      $slickHero.slick('slickNext');
    });
    
    // init slick
    $slickHero.slick({
      arrows: false,
      swipeToSlide: true,
      rows: 0
    });

    $( '.slick-hero' ).on( 'afterChange', function() {
      $( '.progress-circle' ).removeClass( 'progress-anim' );
      $( '.slick-current .progress-circle' ).addClass( 'progress-anim' )
    } )
  }
})
